// extracted by mini-css-extract-plugin
module.exports = {"trigger":"SizeModal_trigger__m1b_R","title":"SizeModal_title__j5Xi7","modalHtml":"SizeModal_modalHtml__ybNV5","load":"SizeModal_load__h7Yea"};